import { Pipe, PipeTransform } from '@angular/core';
import { toDisplayLabel } from '../utils/label.util';

/**
 * Renders any value as a safe, human-readable label.
 *
 * Guards headers, titles and filter summaries against PrimeNG option objects
 * leaking into the view, which otherwise render the literal text
 * "[object Object]".
 *
 * Usage: {{ someValue | safeLabel }}
 */
@Pipe({
  name: 'safeLabel',
  standalone: false,
  pure: true,
})
export class SafeLabelPipe implements PipeTransform {
  transform(value: unknown, fallback = ''): string {
    return toDisplayLabel(value, fallback);
  }
}
